function e(t) {
  return console.log("tetstestsetsetset", JSON.stringify(t)), !1;
}
export {
  e as testLog
};
